import React from "react";
import { GenericPage } from "../../../../../pages";
import { clientRoutes } from "./administration-client.route";
import { planRoutes } from "./administration-plan.route";
import { subscriptionRoutes } from "./administration-subscription.route";
import { fileRoutes } from "./administration-files.route";
import { loginControlRoutes } from "./administration-login-control.route";

export const administrationRoutes = [
  {
    path: "clients",
    element: <GenericPage />,
    children: clientRoutes,
  },
  {
    path: "login-control",
    element: <GenericPage />,
    children: loginControlRoutes,
  },
  {
    path: "plans",
    element: <GenericPage />,
    children: planRoutes,
  },
  {
    path: "files",
    element: <GenericPage />,
    children: fileRoutes,
  },
  {
    path: "subscriptions",
    element: <GenericPage />,
    children: subscriptionRoutes,
  },
];
